export const USD_TO_USDT_ROUTE_ID = "69bd63b13a05415bee83b412";

export const LATAM_AFRICA_FIAT_OPTIONS = [
  { code: "ARS", name: "Argentine Peso", region: "Latin America" },
  { code: "BOB", name: "Bolivian Boliviano", region: "Latin America" },
  { code: "BRL", name: "Brazilian Real", region: "Latin America" },
  { code: "CLP", name: "Chilean Peso", region: "Latin America" },
  { code: "COP", name: "Colombian Peso", region: "Latin America" },
  { code: "CRC", name: "Costa Rican Colón", region: "Latin America" },
  { code: "CUP", name: "Cuban Peso", region: "Latin America" },
  { code: "DOP", name: "Dominican Peso", region: "Latin America" },
  { code: "GTQ", name: "Guatemalan Quetzal", region: "Latin America" },
  { code: "GYD", name: "Guyanese Dollar", region: "Latin America" },
  { code: "HNL", name: "Honduran Lempira", region: "Latin America" },
  { code: "HTG", name: "Haitian Gourde", region: "Latin America" },
  { code: "JMD", name: "Jamaican Dollar", region: "Latin America" },
  { code: "MXN", name: "Mexican Peso", region: "Latin America" },
  { code: "NIO", name: "Nicaraguan Córdoba", region: "Latin America" },
  { code: "PAB", name: "Panamanian Balboa", region: "Latin America" },
  { code: "PEN", name: "Peruvian Sol", region: "Latin America" },
  { code: "PYG", name: "Paraguayan Guaraní", region: "Latin America" },
  { code: "SRD", name: "Surinamese Dollar", region: "Latin America" },
  { code: "UYU", name: "Uruguayan Peso", region: "Latin America" },
  { code: "VES", name: "Venezuelan Bolívar", region: "Latin America" },
  { code: "BZD", name: "Belize Dollar", region: "Latin America" },

  { code: "DZD", name: "Algerian Dinar", region: "Africa" },
  { code: "AOA", name: "Angolan Kwanza", region: "Africa" },
  { code: "BWP", name: "Botswana Pula", region: "Africa" },
  { code: "BIF", name: "Burundian Franc", region: "Africa" },
  { code: "CVE", name: "Cape Verdean Escudo", region: "Africa" },
  { code: "CDF", name: "Congolese Franc", region: "Africa" },
  { code: "DJF", name: "Djiboutian Franc", region: "Africa" },
  { code: "EGP", name: "Egyptian Pound", region: "Africa" },
  { code: "ERN", name: "Eritrean Nakfa", region: "Africa" },
  { code: "ETB", name: "Ethiopian Birr", region: "Africa" },
  { code: "GHS", name: "Ghanaian Cedi", region: "Africa" },
  { code: "GMD", name: "Gambian Dalasi", region: "Africa" },
  { code: "GNF", name: "Guinean Franc", region: "Africa" },
  { code: "KES", name: "Kenyan Shilling", region: "Africa" },
  { code: "KMF", name: "Comorian Franc", region: "Africa" },
  { code: "LRD", name: "Liberian Dollar", region: "Africa" },
  { code: "LSL", name: "Lesotho Loti", region: "Africa" },
  { code: "LYD", name: "Libyan Dinar", region: "Africa" },
  { code: "MAD", name: "Moroccan Dirham", region: "Africa" },
  { code: "MGA", name: "Malagasy Ariary", region: "Africa" },
  { code: "MRU", name: "Mauritanian Ouguiya", region: "Africa" },
  { code: "MUR", name: "Mauritian Rupee", region: "Africa" },
  { code: "MWK", name: "Malawian Kwacha", region: "Africa" },
  { code: "MZN", name: "Mozambican Metical", region: "Africa" },
  { code: "NAD", name: "Namibian Dollar", region: "Africa" },
  { code: "NGN", name: "Nigerian Naira", region: "Africa" },
  { code: "RWF", name: "Rwandan Franc", region: "Africa" },
  { code: "SCR", name: "Seychellois Rupee", region: "Africa" },
  { code: "SDG", name: "Sudanese Pound", region: "Africa" },
  { code: "SLL", name: "Sierra Leonean Leone", region: "Africa" },
  { code: "SOS", name: "Somali Shilling", region: "Africa" },
  { code: "SSP", name: "South Sudanese Pound", region: "Africa" },
  { code: "STN", name: "São Tomé and Príncipe Dobra", region: "Africa" },
  { code: "SZL", name: "Eswatini Lilangeni", region: "Africa" },
  { code: "TND", name: "Tunisian Dinar", region: "Africa" },
  { code: "TZS", name: "Tanzanian Shilling", region: "Africa" },
  { code: "UGX", name: "Ugandan Shilling", region: "Africa" },
  { code: "XAF", name: "Central African CFA Franc", region: "Africa" },
  { code: "XOF", name: "West African CFA Franc", region: "Africa" },
  { code: "ZAR", name: "South African Rand", region: "Africa" },
  { code: "ZMW", name: "Zambian Kwacha", region: "Africa" },
  { code: "ZWL", name: "Zimbabwe Gold / Zimbabwe currency", region: "Africa" },
];